<template>
  <div class="orderDetail">
    <div class="cardInline">
      <Row class="item border-line">
        <Col span="12" class="card lf">成单数</Col>
        <Col span="12" class="card lf"></Col>
      </Row>
      <Row class="item">
        <Col span="8" class="card card2">
          <Tag color="green">今日</Tag>
          <b>{{cardInline.todayOrderCount}}</b>单
        </Col>
        <Col span="8" class="card card2">
          <Tag color="blue">本月</Tag>
          <b>{{cardInline.monthOrderCount }}</b>单
        </Col>
        <Col span="8" class="card">
          <Tag color="orange">近三月</Tag>
          <b>{{cardInline.threeMonthOrderCount }}</b>单
        </Col>
      </Row>
    </div>
    <Tabs class="tabChange">
      <TabPane label="订单列表" icon="md-list">
        <div class="filter">
          <div class="box">
            <span class="title">状态：</span>
            <RadioGroup v-model="radioVal" @on-change="radioChange">
              <Radio label="0" border>全部</Radio>
              <Radio label="1" border>未支付</Radio>
              <Radio label="2" border>已支付</Radio>
            </RadioGroup>
          </div>
          <div class="box">
            <span class="title">条件：</span>
            <Input v-model="input1" placeholder="用户名" style="width: 200px"/>
            <DatePicker class="time" @on-change="timesChange1" v-model="time1" type="daterange" placement="bottom-end"
                        placeholder="请选择开始时间，结束时间" :editable='false' style="width: 220px"></DatePicker>
            <Button type="primary" @click="search1">查询</Button>
            <Button class="reset" @click="reset1">重置</Button>
          </div>
        </div>
        <div class="tbl">
          <Table :loading="loading1" border :columns="columns1" :data="tblData1"></Table>
          <Page @on-change="pageChange1" @on-page-size-change="pageSizeChange1" :total="total1"
                :page-size="params1.pgSize" :current="params1.pgIndex" show-total show-elevator
                show-sizer></Page>
        </div>
      </TabPane>
      <TabPane label="退款记录" icon="md-create">
        <div class="filter">
          <div class="box">
            <span class="title">条件：</span>
            <Input v-model="input2" placeholder="用户名" style="width: 200px"/>
            <DatePicker class="time" v-model="time2" @on-change="timesChange2" type="daterange" placement="bottom-end"
                        placeholder="退款时间" :editable='false' style="width: 220px"></DatePicker>
            <Button type="primary" @click="search2">查询</Button>
            <Button class="reset" @click="reset2">重置</Button>
          </div>
        </div>
        <div class="tbl">
          <Table :loading="loading2" border :columns="columns2" :data="tblData2"></Table>
          <Page @on-change="pageChange2" @on-page-size-change="pageSizeChange2" :total="total2"
                :page-size="params2.pgSize" :current="params2.pgIndex" show-total show-elevator
                show-sizer></Page>
        </div>
      </TabPane>
    </Tabs>
    <div class="showInfo">
      <Modal v-model="showModel" title="查看订单明细" width="1000" footer-hide>
        <info ref="info" v-if="showModel" :modalVal="modalVal"/>
      </Modal>
    </div>
  </div>
</template>

<script>
  import info from "./info";

  export default {
    name: "orderDetail",
    components: {
      info
    },
    data() {
      return {
        previewModal: false,
        modalVal: {},
        showModel: false,
        status: [
          {},
        ],
        cardInline: {},
        radioVal: '0',
        input1: '',
        time1: ['', ''],
        loading1: true,
        columns1: [
          {
            title: "订单编号",
            key: "orderID",
            width: 160
          },
          {
            title: "用户名",
            key: "userName",
          },
          // {
          //   title: "姓名",
          //   key: "trueName",
          // },
          // {
          //   title: "手机号码",
          //   key: "mobilePhone",
          // },
          {
            title: "订单金额",
            key: "classMoney",
          },
          {
            title: "实付金额",
            key: "payMoney",
          },
          {
            title: "订单状态",
            key: "payStatus",
            render: (h, params) => {
              if (params.row.payStatus === 1) {
                return h("span", {
                  style: {
                    color: '#bebebe'
                  }
                }, "未支付")
              } else if (params.row.payStatus === 3) {
                return h("span", {
                  style: {
                    color: '#FF9900'
                  }
                }, "已支付")
              } else if (params.row.payStatus === 6) {
                return h("span", {
                  style: {
                    color: '#a569f1'
                  }
                }, "已退款")
              }
            }
          },
          {
            title: "报名时间",
            key: "addTime",
            width: 200
          },
          {
            title: "支付时间",
            key: "payTime",
            width: 200
          },
          {
            title: "操作",
            key: "action",
            width: 100,
            render: (h, params) => {
              return h("span", {
                style: {
                  color: '#e13b29',
                  cursor: 'pointer'
                },
                on: {
                  click: () => {
                    this.orderInfo(params.row);
                  }
                }
              }, "查看详情")
            }
          },
        ],
        tblData1: [],
        params1: {
          unionID: '',
          seacherContext: '',
          type: '0',
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        },
        total1: 0,
        input2: '',
        time2: ['', ''],
        loading2: true,
        columns2: [
          {
            title: "订单编号",
            key: "orderID",
            width: 160
          },
          {
            title: "退款时间",
            key: "refoundTime",
            width: 200
          },
          {
            title: "用户名",
            key: "userName",
          },
          // {
          //   title: "姓名",
          //   key: "trueName",
          // },
          // {
          //   title: "手机号码",
          //   key: "mobilePhone",
          // },
          {
            title: "退款金额",
            key: "refoundMoney",
          },
          {
            title: "退款原因",
            key: "refoundReason",
            render: (h, params) => {
              const val = this.reason.findIndex((value) => value.num === params.row.refoundReason);
              console.log(val);
              return h("span", {
                style: {
                  // color: '#f5222d'
                }
              }, this.reason[val].value)
            }
          },
          {
            title: "退款状态",
            key: "payStatus",
            width: 200,
            render: (h, params) => {
              const val = this.state.findIndex((value) => value.num === params.row.payStatus);
              return h("span", {
                style: {
                  color: '#f5222d'
                }
              }, this.state[val].value)
            }
          },
          // {
          //   title: "操作",
          //   key: "action",
          //   width: 100,
          //   render: (h, params) => {
          //     console.log(params)
          //     return h("span", {
          //       style: {
          //         color: '#1890FF',
          //         cursor: 'pointer'
          //       },
          //       on: {
          //         click: () => {
          //           console.log(params.row);
          //           this.orderInfo(params.row);
          //         }
          //       }
          //     }, "查看详情")
          //   }
          // },
        ],
        tblData2: [],
        params2: {
          unionID: '',
          seacherContext: '',
          // type: '4',
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        },
        total2: 0,
        state: [
          {
            num: 1,
            value: '未支付'
          }, {
            num: 3,
            value: '付款'
          }, {
            num: 4,
            value: '退款'
          }
        ],
        reason: [
          {
            num: 0,
            value: '重复付款'
          }, {
            num: 1,
            value: '优惠退款'
          }, {
            num: 2,
            value: '教材退款'
          }, {
            num: 3,
            value: '换课退款'
          }, {
            num: 4,
            value: '视频网络'
          }, {
            num: 5,
            value: '老师讲授'
          }, {
            num: 6,
            value: '课程更新'
          }, {
            num: 7,
            value: '客服沟通'
          }, {
            num: 8,
            value: '学员报名'
          }, {
            num: 9,
            value: '客户端问题'
          }, {
            num: 10,
            value: '投诉退款'
          }, {
            num: 11,
            value: '取消考试'
          }, {
            num: 12,
            value: '网校误导学员'
          }, {
            num: 13,
            value: '教材不符'
          }, {
            num: 14,
            value: '程序BUG'
          }, {
            num: 15,
            value: '课程下线'
          }, {
            num: 16,
            value: '没时间学习'
          }, {
            num: 17,
            value: '题库错误'
          }, {
            num: 18,
            value: '地区考试与网校课程不符'
          }, {
            num: 19,
            value: '其他原因'
          }, {
            num: 20,
            value: '无法参加考试'
          }, {
            num: 21,
            value: '不适合自己'
          }, {
            num: 22,
            value: '难度大听不懂'
          }, {
            num: 23,
            value: '保价退款'
          }, {
            num: 24,
            value: '课程质量'
          }, {
            num: 25,
            value: '报考失败'
          }, {
            num: 26,
            value: '差价退款'
          }, {
            num: 27,
            value: '考试不过退费'
          }, {
            num: 28,
            value: '选择其他网校'
          }
        ]
      }
    },
    methods: {
      radioChange(e) {
        this.params1.type = e;
        this.orderList1();
      },
      orderInfo(val) {
        this.showModel = true;
        // this.previewModal = true;
        this.modalVal = val;
      },
      pageChange1(val) {
        this.params1.pgIndex = val;
        this.orderList1();
      },
      pageSizeChange1(val) {
        this.params1.pgSize = val;
        this.orderList1();
      },
      pageChange2(val) {
        this.params2.pgIndex = val;
        this.orderList2();
      },
      pageSizeChange2(val) {
        this.params2.pgSize = val;
        this.orderList2();
      },
      timesChange1(e) {
        console.log(e);
        this.time1 = e;
      },
      timesChange2(e) {
        console.log(e);
        this.time2 = e;
      },
      search1() {
        console.log(this.time1);

        this.params1 = {
          unionID: '',
          seacherContext: this.input1,
          type: this.radioVal,
          startTime: this.time1[0],
          endTime: this.time1[1],
          pgIndex: 1,
          pgSize: 10,
        };
        console.log(this.params1);
        this.orderList1();
      },
      reset1() {
        this.loading1 = true;
        this.input1 = '';
        this.time1 = ['', ''];
        this.radioVal = '0';
        this.params1 = {
          unionID: '',
          seacherContext: '',
          type: '0',
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        };
        this.total1 = 0;
        this.tblData1 = [];

        this.orderList1();
      },
      search2() {
        this.params2 = {
          unionID: '',
          seacherContext: this.input2,
          startTime: this.time2[0],
          endTime: this.time2[1],
          pgIndex: 1,
          pgSize: 10,
        };
        this.orderList2();
      },
      reset2() {
        this.loading2 = true;
        this.input2 = '';
        this.time2 = ['', ''];
        this.radioVal = '0';
        this.params2 = {
          unionID: '',
          seacherContext: '',
          startTime: '',
          endTime: '',
          pgIndex: 1,
          pgSize: 10,
        };
        this.total2 = 0;
        this.tblData1 = [];

        this.orderList2();
      },
      getStatic() {
        this.$store.dispatch('effect/orderStatic').then(res => {
          this.cardInline = res;
        })
      },
      orderList1() {
        this.$store.dispatch('effect/orderList', this.params1).then(res => {
          if (res.s === 10006) {
            this.loading1 = false;
            this.tblData1 = res.list;
            this.total1 = res.count;
          } else {
            this.loading1 = false;
            this.tblData1 = [];
            this.total1 = 0;
          }
        })
      },
      orderList2() {
        this.$store.dispatch('effect/refoundList', this.params2).then(res => {
          if (res.s === 10006) {
            this.loading2 = false;
            this.tblData2 = res.list;
            this.total2 = res.count;
          } else {
            this.loading2 = false;
            this.tblData2 = [];
            this.total2 = 0;
          }
        })
      },
      getInfo() {
        this.getStatic();
        this.orderList1();
        this.orderList2();
      },
      getTime() {
        let now = new Date();
        let month = now.getMonth() + 1;
        let year = now.getFullYear();
        let nextMonthFirstDay = new Date([year, month + 1, 1].join('-')).getTime();
        let oneDay = 1000 * 24 * 60 * 60;
        let monthLast = new Date(nextMonthFirstDay - oneDay).getDate()
        let s = [year, month < 10 ? '0' + month : month, '0' + 1].join('-');
        let e = [year, month < 10 ? '0' + month : month, monthLast < 10 ? '0' + monthLast : monthLast].join('-');
        //this.time1 = [s, e];
        // console.log(this.time1);
        this.params1.startTime = s;
        this.params1.endTime = e;
      }
    },
    created() {
      if (this.$route.query.type) {
        this.params1.type = this.$route.query.type;
        this.radioVal = this.$route.query.type;
        this.getTime();
      }
      this.getInfo();
    }
  }
</script>
<style scoped lang="scss">
  .orderDetail {
    .cardInline {
      margin-bottom: 20px;
      border: 1px solid #E8EAEC;

      .item {
        line-height: 40px;

        .card {
          padding: 0 16px;

          .ivu-tag {
            float: left;
            margin-top: 9px;
            margin-right: 8px;
          }
        }

        .card2 {
          border-right: 1px solid #E8EAEC;
        }

        .rt {
          text-align: right;
        }
      }

      .border-line {
        border-bottom: 1px solid #E8EAEC;
      }
    }

    .tabChange {
      min-height: 500px;

      .filter {
        text-align: left;
        margin-bottom: 20px;

        .box {
          margin-bottom: 10px;

          .title {
            min-width: 80px;
            display: inline-block;
            vertical-align: -4px;
          }

          .buttonList {
            width: calc(100% - 80px);
            vertical-align: top;

            .ivu-btn {
              margin-bottom: 10px;
            }
          }

          .time {
            margin: 0 10px;
          }

          .reset {
            margin-left: 10px;
          }
        }
      }

      .tbl {
        .ivu-page {
          text-align: right;
          margin: 20px 0;
        }
      }
    }

  }
</style>